import { useMutation } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ApiError, arrayRequestBody } from 'openapi-typescript-fetch'
import { type BadgeLEDTO } from 'types/api'

export const useManageBadgeLEs = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => Promise<void>
  onError?: (error: ApiError) => void
}) => {
  const post = useTypedApiClient({
    path: '/admin/badges/{badgeRewardId}/licensed-establishments/participating',
    method: 'post',
  })

  return useMutation({
    mutationKey: [
      'admin/badges/{badgeRewardId}/licensed-establishments/participating',
    ],
    mutationFn: async ({
      badgeRewardId,
      req,
    }: {
      badgeRewardId: number
      req: BadgeLEDTO[]
    }) => {
      return await post(arrayRequestBody(req, { badgeRewardId }))
    },
    onSuccess: async () => {
      if (onSuccess) {
        await onSuccess()
      }
    },
    onError,
  })
}
